var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-layout',{attrs:{"direction":"column","gap":"4"}},[_c('markdown-renderer',{attrs:{"html":_vm.sanitizedContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }